import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const SiteContext = createContext({ settings: {}, pages: [], refresh: () => {} });

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [pages, setPages] = useState([]);

  const load = useCallback(async () => {
    try {
      const [sR, pR] = await Promise.all([
        axios.get(`${API}/site/settings`),
        axios.get(`${API}/site/pages`),
      ]);
      setSettings(sR.data.settings || {});
      setPages(pR.data.pages || []);
    } catch {}
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <SiteContext.Provider value={{ settings, pages, refresh: load }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
